export default function initLoader() {
    const loader = document.querySelector(".loader__container")
    if (loader) {
        const logoPath = document.querySelector(".loader__logo-logo svg path")
        // const length = logoPath.getTotalLength()
        //
        //
        // logoPath.setAttribute("stroke-dasharray", length)
        // logoPath.setAttribute(`stroke-dashoffset`, -length)
        // // alert(length)
        //
        //
        // // alert(logoPath.outerHTML)
        // console.log(logoPath)

        loader.classList.add("animate")
        logoPath.parentElement.setAttribute('style', 'opacity: 1')
    }
}
